<template >
  <div
    class="container"
    style="margin-top: 40px; width:1000px"
    v-if="lesson"
    :key="componentKey"

  >
    <div class="row justify-content-between">
      <h3>Жилийн эцсийн дүн</h3>
    </div>
    <div class="row justify-content-center px-5 py-5">
      <div class="col">
        <div class="text-center">
          <ul class="menutabs">
            <li
              class="tabli"
              v-if="allGroups == false"
              v-for="(group, gindex) in groups"
              v-bind:class="tab_selected == gindex ? 'bottom-bordered' : ''"
              @click="_showStudents(group, gindex)"
              :key="gindex"
            >
              <h3
                class="tabText"
                style="text-decoration: none"
                v-if="group.isGroup && group.isGroup == true"
              >
                {{ _getGroupName(group) }}
              </h3>
              <h3
                class="tabText text-uppercase"
                style="text-decoration: none"
                v-else
              >
                <span
                  >{{ group.departmentName }}/{{ group.programName }}
                  <span class="op">({{ group.students.length }})</span></span
                >
              </h3>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <hr />
    <div class="card mb-4" v-if="lesson.groups && lesson.groups.length > 0">
      <div class="card-header py-3">
        <div class="d-flex justify-content-between align-items-center">
          <h3 class="m-0 font-weight-bold text-primary">
            {{ lesson.name }}/ {{ currentSelectedGroup.students.length }}
          </h3>
          <span class="text-danger" style="font-size: 11pt"
            >{{ actionstatus }} {{ _getCurrentDate() }}</span
          >
        </div>
      </div>
      <div class="card-body">
        <div>
          <table class="table table-bordered table-sm score-table">
            <thead>
              <tr>
                <th style="width: 4%"></th>
                <th class="text-primary">Сурагч</th>
                <th class="text-primary scorehead" style="width:20%">
                  Эцсийн дүн<span class="float-right"
                    ><i
                      @click="_clearFinalScore()"
                      class="text-danger fas fa-times"
                      style="cursor: pointer"
                    ></i
                  ></span>
                </th>
              </tr>
            </thead>
            <tbody
              v-for="(group, gindex) in groups"
              v-if="allGroups"
              :key="gindex"
            >
              <tr
                v-if="allGroups == true && group.students.length > 0"
                style="background-color: #f1f1f1"
              >
                <td
                  colspan="10"
                  class="text-primary"
                  style="text-transform: uppercase"
                  v-if="group.isGroup && group.isGroup == true"
                >
                  {{ gindex + 1 }}.{{ group.groupName }}
                </td>
                <td
                  colspan="10"
                  class="text-primary"
                  style="text-transform: uppercase"
                  v-else
                >
                  <span>
                    {{ group.departmentName }}/{{ group.programName }}</span
                  >
                </td>
              </tr>
              <tr v-for="(student, sindex) in group.students" :key="sindex">
                <td>{{ sindex + 1 }}</td>
                <td @click="_detailOfstudent(student)">
                  <span v-if="student.lastname && student.lastname.length > 0">
                    <span
                      v-if="
                        student.lncount &&
                        student.lncount > 1 &&
                        student.lastname.length >= student.lncount
                      "
                      >{{
                        student.lastname.substring(0, student.lncount)
                      }}</span
                    >
                    <span v-else>{{ student.lastname[0] }}</span
                    >.
                  </span>
                  {{ student.name }}
                 
                </td>
      
                <td>
                  <input
                    class="form-control input-sm alignRight"
                    type="number"
                    v-model="student.finalYearScore"
                    @change="finalScoreChanged(student)"
                  />
                </td>
              </tr>
            </tbody>
            <tbody v-if="allGroups == false">
              <tr
                v-for="(student, sindex) in currentSelectedGroup.students"
                :key="sindex"
              >
                <td>{{ sindex + 1 }}</td>
                <td>
                  <span v-if="student.lastname && student.lastname.length > 0">
                    <span
                      v-if="
                        student.lncount &&
                        student.lncount > 1 &&
                        student.lastname.length >= student.lncount
                      "
                      >{{
                        student.lastname.substring(0, student.lncount)
                      }}</span
                    >
                    <span v-else>{{ student.lastname[0] }}</span
                    >.
                  </span>
                  <span
                    style="cursor: pointer"
                    @click="_detailOfstudent(student)"
                    >{{ student.name }}
                  </span>
                  <span style="color: #bbb">{{ student.lastname }}</span>
                </td>
                <td v-if="student.finalYearScore!=null">
                  <input
                    v-bind:class="[
                      student.finalYearScore && student.finalYearScore > 50
                        ? 'bg-success-light'
                        : 'bg-danger-light',
                    ]"
                    class="input-sm form-control alignLeft"
                    placeholder="Оноо оруулаагүй!"
                    type="number"
                    v-model.number="student.finalYearScore"
                    @change="finalScoreChanged(student)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else class="alert alert-warning text-center mb-4">
      <h4>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4>
    </div>
  </div>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
import moment, { max } from "moment";
import firebase from "firebase";
import VueQrcode from "vue-qrcode";
import LessonInfo from "../shared/LessonInfo";
export default {
  name: "ILessonScores",

  data() {
    return {
      componentKey: 0,
      currentSelectedGroup: null,
      allGroups: false,
      tab_selected: 0,
      actionstatus: null,
      lesson: null,
      topic: null,
      content: { name: null, totalScore: 100, totalProcent: null },
      topics: [],
      types: [],
      selectedType: null,
      studentsText: "",
      selectedTopic: null,
      tmpStudents: [],

      display: 0,
      tagText: null,
      dayStr: null,
      selectedCell: null,
      selectedTopicIndex: null,
      selectedGroupIndex: null,
      schools: [],
      teachers: [],

      school: null,
      department: null,
      program: null,

      teacher: null,
      groups: [],
      currentSelectedStudent: null,
      savingFinalGrades: false,
    };
  },
  methods: {
    _getWarningText() {
      if (this.savingFinalGrades == true)
        return "Дүн xадгалж байна. Xадгалсан мэдэгдэл гартал түр xүлээнэ үү!";
      else return "Дүн мэдээлэx";
    },
    _notification() {
      alert("Та дүнгээ мэдээлсэн байна.");
    },
     
    _getCurrentDate() {
      var val = new Date();
      return moment(val).format("MM.DD | HH:mm");
      // if (!val) { return '-' }
      // let date = val.toDate()
      // return moment(date).format('MM/DD/YYYY HH:mm');
    },
  
    async _showStudents(group, index) {
      this.currentSelectedGroup = group;
      this.tab_selected = index;
      await this.getStudentsFromGroup(this.currentSelectedGroup);
    },
    _detailOfstudent(student) {
      console.log(student);
      this.currentSelectedStudent = student;
    },
    _splitName(name) {
      if (name && name.includes("/")) {
        var n = name.indexOf("/");
        return name
          .substring(n, name.length)
          .replaceAll("/", "")
          .replaceAll("-", "/");
      }
      return name;
    },
    _getGroupName(group) {
      if (group.isGroup) {
        return this._splitName(group.groupName);
      } else return group.groupName;
    },
    async _initData() {
      var doc = await fb.db
        .collection("schools/" + this.schoolId + "/lessons")
        .doc(this.lessonId)
        .get();
      let lesson = doc.data();
      lesson.id = doc.id;
      lesson.ref = doc.ref;
      this.lesson = lesson;
       
      this.groups = [];
      if (this.programId && this.programId != "") {
        for (const group of this.lesson.groups) {
          console.log(group);
          if (group && group.program && group.program.id == this.programId) {
            var grp = Object.assign({}, group);
            grp.students = [];
            grp.count = 0;
            this.groups.push(grp);
          }
        }
      } else if (this.groupId && this.groupId != "") {
        for (const group of this.lesson.lessonGroups) {
          console.log("group");
          if (group && group.group && group.group.id == this.groupId) {
            var grp = Object.assign({}, group);
            grp.students = [];
            grp.count = 0;
            grp.isGroup = true;
            this.groups.push(grp);
          }
        }
      }
      // group uusgej huuhed songodog groupuud
      else {
        if (
          this.lesson.isGroup != null &&
          this.lesson.isGroup != undefined &&
          this.lesson.isGroup == true
        ) {
          for (const group of this.lesson.lessonGroups) {
            console.log(group);
            var grp = Object.assign({}, group);
            grp.students = [];
            grp.count = 0;
            grp.isGroup = true;
            this.groups.push(grp);
          }
        } else
          for (const group of this.lesson.groups) {
            var grp = Object.assign({}, group);
            grp.students = [];
            grp.count = 0;
            this.groups.push(grp);
          }
      }
      if (this.groups.length > 0 && this.currentSelectedGroup == null) {
        this.currentSelectedGroup = this.groups[0];
      }

      //await this.getTopics();
      await this.getStudents();
    },

    async _getStudentFrom(studentsSnapshot, students) {
      for (const doc of studentsSnapshot.docs) {
        let student = doc.data();
        student.id = doc.id;
        student.ref = doc.ref;
        student.finalYearScore = 0
        student.finalYearScoreBAK = 0  
        fb.db
          .collection(
            "schools/" +
              this.schoolId +
              "/lessons/" +
              this.lessonId +
              "/studentList"
          )
          .doc(student.id)
          .onSnapshot((studentDoc) => {
            //console.log(studentDoc)
            if(studentDoc.exists){
              //console.log(studentDoc.data().finalYearScore)
              if(studentDoc.data().finalYearScore){
                student.finalYearScore = studentDoc.data().finalYearScore
                student.finalYearScoreBAK = studentDoc.data().finalYearScore
              }
            }else{
              console.log('ddd')
              student.finalYearScore = 0
              student.finalYearScoreBAK = 0
            }
          });
        students.push(student);
      }
    },
    async getStudentsFromGroup(group) {
      var studentsSnapshot;
      if (group.isGroup && group.isGroup == true) {
        studentsSnapshot = await fb.db
          .collection("schools/" + this.schoolId + "/students")
          .where("lessonGroups", "array-contains", group.group)
          .orderBy("name", "asc")
          .get();
      } else {
        studentsSnapshot = await fb.db
          .collection("schools/" + this.schoolId + "/students")
          .where("program", "==", group.program)
          .orderBy("name", "asc")
          .get();
      }
      if (studentsSnapshot && !studentsSnapshot.empty) {
        group.students = [];
        await this._getStudentFrom(studentsSnapshot, group.students);
      }
    },
    async getStudents() {
      if (
        this.lesson != null &&
        this.lesson != undefined &&
        this.lesson.groups &&
        this.lesson.groups.length > 0
      ) {
        if (this.allGroups) {
          for (const group of this.groups) {
            this.getStudentsFromGroup(group);
          }
        } else {
          this.getStudentsFromGroup(this.currentSelectedGroup);
        }
      }
    },
    async finalScoreChanged(student) {
      console.log(student)
      if(student.finalYearScore){
        console.log(student.finalYearScore)
      }else{
        console.log(student.finalYearScore)
      }
      if (student && student.id && student.finalYearScore>=0&&student.finalYearScore<=100) {
        this.lesson.ref
          .collection('studentList')
          .doc(student.id)
          .set({ finalYearScore: student.finalYearScore }, { merge: true })
          .then((xx) => {
  
            student.ref.collection('finalGrades').doc(this.lesson.id).set({
              finalYearScore: student.finalYearScore 
            },{merge:true}).then(()=>{})

            this.actionstatus =
            student.name + ", " + student.finalYearScore + " дүн xадгалагдсан: ";
          });
      }else{
        if(student.finalYearScore<0||student.finalYearScore>100) {
          confirm('Зөв дүн оруулна! : ' + student.finalYearScore)
          student.finalYearScore = student.finalYearScoreBAK
        }
        else{
          confirm('Ямар нэгэн буруу явагдлаа!')
        }
      }
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  components: {
    VueQrcode,
    LessonInfo,
  },
  props: {
    schoolId: {
      required: true,
    },
    lessonId: {
      required: true,
    },
    programId: {
      required: false,
    },
    groupId: {
      required: false,
    },
  },
  created() {
    fb.db
      .collection("schools")
      .doc(this.schoolId)
      .onSnapshot((doc) => {
        let school = doc.data();
        school.id = doc.id;
        this.school = school;
      });

    fb.db
      .collection("schools")
      .doc(this.schoolId)
      .onSnapshot((doc) => {
        let school = doc.data();
        school.id = doc.id;
        this.school = school;
      });

    if (this.lessonId != null && this.lessonId != "") {
      this._initData();
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
  },
};
</script>


<style>
::placeholder {
  color: #bbb !important;
  font-size: 10pt;
}
.scorehead {
  width: 12%;
}
.score-table.form-control {
  height: calc(1.8em) !important;
  border-radius: 0rem;
}
.score-table {
  width: 100%;
  margin-bottom: 1rem;
  color: #000;
}
.alignRight {
  text-align: right;
}
.alignLeft {
  text-align: left;
}
.table td,
.table th {
  vertical-align: middle;
  border-top: 1px solid #e3e6f0;
}
.b3-collapsing-form-additional-icons {
  display: inline-block;
  height: 24px;
  margin-bottom: -12px;
  margin-top: -12px;
  padding: 12px;
}
.svg-icon {
  cursor: pointer;
  display: inline-block;
  fill: #80868b;
  /* rgba(0,0,0,0.38);  */
  -webkit-transition: fill 0.25s linear;
  transition: fill 0.25s linear;
  width: 24px;
}
.svg-icon:hover {
  fill: rgba(0, 0, 0, 0.78);
}
</style>
